import React, { useContext } from "react";

const userDefaultValues = { name: "user", preferredUsername: "user", licensingTiers: [] };
const AuthContext = React.createContext(userDefaultValues);

export const AuthProvider = AuthContext.Provider;

// custom hook so we can mock the result in tests
export const useAuthContext = () => useContext(AuthContext);
